import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContractTemplatesService {

  constructor(private http: HttpClient) { }

  getData(filter?: any): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}contract_genrator`, filter);
  }
  getById(id: string): Observable<object> {
    return this.http.post(`${environment.apiUrl}contract_genrator/view/${id}`, '');
  }

  createData(data: any): Observable<object> {
    return this.http.post(`${environment.apiUrl}contract_genrator/create`, data);
  }

  updateData(contractId: string, data: any): Observable<object> {
    return this.http.put(`${environment.apiUrl}contract_genrator/update/${contractId}`, data);
  }

  deleteData(data: any): Observable<any> {
    return this.http.delete(`${environment.apiUrl}contract_genrator/delete/${data.contract_id}`, data);
  }

  getListData(filter: any): Observable<object> {
    return this.http.post<any[]>(`${environment.apiUrl}contract_genrator`, filter);
  }

  getPDF(filter: any, preview: any, id: any, model: any, folder: any): Observable<any[]> {
    return this.http.post<any[]>(`${environment.yiiUrl}pdf/genrate-contract?model=${model}&id=${id}&property_id=${id}&priview=${preview}&folder=${folder}`, filter);
  }

  getAttachments(id: any, model: any, document?: boolean): Observable<any[]> {
    document = document === true ?  document : false;
    return this.http.get<any[]>(`${environment.yiiUrl}attachments/get-attachments?id=${id}&modelName=${model}&document=${document}`);
  }

  getPropertiesAttachments(id: any): Observable<any[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<any[]>(`${environment.yiiUrl}properties/get-attachments?p_id=${id}`);
  }

  previewTemp(data: any): Observable<any[]> {
    return this.http.post<any[]>(`${environment.yiiUrl}pdf/preview-contracts`, data);
  }
}
